var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 17L1.87778 18.737C1.77748 18.7671 1.67065 18.7754 1.56612 18.761C1.46158 18.7467 1.36234 18.7101 1.27659 18.6544C1.19084 18.5988 1.12103 18.5255 1.07294 18.4408C1.02485 18.356 0.999846 18.2622 1 18.167V3.433C1.00003 3.30714 1.04403 3.18447 1.12579 3.08236C1.20754 2.98025 1.32291 2.90386 1.45556 2.864L7.66667 1M7.66667 17L14.3333 19M7.66667 17V1M7.66667 1L14.3333 3M14.3333 19L20.5444 17.137C20.6773 17.0971 20.7928 17.0205 20.8745 16.9182C20.9563 16.8159 21.0002 16.693 21 16.567V1.832C21 1.73692 20.9748 1.6432 20.9267 1.55857C20.8785 1.47394 20.8087 1.40083 20.723 1.34526C20.6372 1.28969 20.5381 1.25325 20.4336 1.23895C20.3292 1.22465 20.2224 1.23289 20.1222 1.263L14.3333 3M14.3333 19V3",
    stroke: "#034A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d1ba8b61b8a28cbc66570737044f25d4.svg";
export { ForwardRef as ReactComponent };